import update from 'immutability-helper';
import get from 'lodash/get';
import getGuideItemPathname from 'src/common/utils/guideItem/getGuideItemPathname';
import defaultPaymentCompletionItems from '../components/payment/PaymentCompletionDefaults';
import { fulfilled, pending, rejected } from './utils/asyncActionNameSuffixes';
import createMappedReducer from './utils/createMappedReducer';
import { FETCH_PAYMENT_COMPLETION_ITEMS } from '/src/common/actions/paymentCompletion';
import { LINE_BREAK_INSTRUCTION } from '/src/common/constants/localizations/shared';

const initialState = {
  categoryItems: {
    items: defaultPaymentCompletionItems,
  },
};

export const paymentCompletion = createMappedReducer(initialState, {
  [pending(FETCH_PAYMENT_COMPLETION_ITEMS)](state) {
    return update(state, {
      categoryItems: {
        $merge: { isFetching: true },
      },
    });
  },
  [rejected(FETCH_PAYMENT_COMPLETION_ITEMS)](state, action) {
    return update(state, {
      categoryItems: {
        $merge: {
          loadedTime: action.payload.loadedTime,
          isFetching: false,
        },
      },
    });
  },
  [fulfilled(FETCH_PAYMENT_COMPLETION_ITEMS)](state, action) {
    const containerItems = get(action, 'payload.content.containerItems', []);

    const items = containerItems.map((guideItem) => {
      const parentProgram = get(guideItem, 'properties.parentProgram', {});
      const href = getGuideItemPathname(guideItem, parentProgram);
      const guideItemText = get(guideItem, 'title', '');
      const strings = guideItemText.split(LINE_BREAK_INSTRUCTION);
      const bgColor = get(guideItem, 'presentation.backgroundColor', '');
      const image = get(guideItem, 'properties.landscapeImage.imageUrl', '');

      return {
        guideItem,
        title: get(strings, '[0]'),
        subtitle1: get(strings, '[1]'),
        subtitle2: get(strings, '[2]'),
        href,
        bgColor,
        image,
      };
    });

    return update(state, {
      categoryItems: {
        $merge: {
          items,
          loadedTime: action.payload.loadedTime,
          isFetching: false,
        },
      },
    });
  },
});
